import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { RenderCategoryLayoutElement } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/RenderCategoryLayoutElement";
import { useLayoutElementsRequestId } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/useLayoutElementsRequestId";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";
import React from "react";
export var RenderCategoryPageLayoutElements = function(param) {
    var layoutElements = param.layoutElements;
    var categoryModel = useCurrentCategoryModel();
    var requestId = useLayoutElementsRequestId();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: layoutElements.map(function(layoutElement, index) {
            return /*#__PURE__*/ _jsx(RenderCategoryLayoutElement, {
                layoutElement: layoutElement,
                category: categoryModel,
                requestId: requestId,
                index: index
            }, "category-layout-element-".concat(index));
        })
    });
};
